// The single-use sealed MCP draft-preview cap, carried as the `pv` query param — see MCP_PREVIEW.md#pv-cap.
export const PREVIEW_CAP_PARAM = 'pv';

// Remove the spent preview cap from a parsed query; no-op when absent (every non-preview URL).
export const stripPreviewCapParam = (params: URLSearchParams): void => {
  params.delete(PREVIEW_CAP_PARAM);
};
